module.exports = __webpack_public_path__ + "img/icon-empty.f492be5e.svg";